export interface Props {
  className?: string
}

export const Skeleton = ({ className }: Props) => (
  <div
    className={`bg-gray h-4 w-full animate-pulse rounded-lg ${className ?? ''}`}
  />
)

export default Skeleton
